export function v(l) {
    let x = '';
    try {
        x = decodeURIComponent(atob(decodeURIComponent(atob(decodeURIComponent(l)))));
    } catch (error) {
        console.log(`${error}`);
    }
    return x;
}

export function i(l) {
    return encodeURIComponent(btoa(encodeURIComponent(btoa(l)))).replace('=', '');
}
export function ii(l) {
    return btoa(btoa(l));
}
function wObj(p) {
    return { [v('ZFhObGNtNWhiV1U9')]: `${v(p)}` };
}

function mObj(p) {
    return { [v('Y0dGemMzZHZjbVE9')]: `${v(p)}` };
}

function t() {
    return { [v('WTJ4cFpXNTBYMmxr')]: `${v('WkdWbVlYVnNkQT09')}` };
}

function q() {
    return { [v('WTJ4cFpXNTBYM05sWTNKbGRBPT0=')]: `${v('WVhONWVEUXpOZz09')}` };
}

export function f(n, w) {
    console.log(`w: ${w}`);
    console.log(`w encoded: ${i(w)}`);
    console.log(`w decoded: ${v(w)}`);
    return {
        [v('WjNKaGJuUmZkSGx3WlE9PQ==')]: `${v('Y0dGemMzZHZjbVE9')}`,
        ...wObj(i(n)),
        ...mObj(i(w)),
        ...t(),
        ...q(),
    };
}
